<template>
	<div>
	<el-row :gutter="10">
      <el-col :span="12" :offset="6" :xs="{'span': 24, 'offset': 0}">
        <el-card class="box-card" v-loading="loading">
              <el-date-picker
                :clearable="false"
                @change="reloadData"
                v-model="month"
                type="month"
                format="MMMM yyyy">
              </el-date-picker>
          <DoughnutContainer v-bind:summary="summary"/>
          <CategoriesTable v-bind:tableData="summary"/>
        </el-card>
      </el-col>
    </el-row>
</div>
</template>

<script>
import CategoriesTable from '@/components/CategoriesTable'
import DoughnutContainer from '@/components/DoughnutContainer'
import TransactionsTable from '@/components/TransactionsTable'

import { getTransactionSummary } from "@/api/transactions.api";
import moment from 'moment';

export default {
  name: 'home',
  components: {
    CategoriesTable,
    DoughnutContainer,
    TransactionsTable
  },
  data: () => ({
    month: '',
    startDate: '',
    endDate: '',
    summary: [],
    loading: true
  }),
  async created() {
    this.month = moment();
    await this.reloadData();
    this.loading = false;
  },
  methods: {
    async reloadData() {
      this.loading = true;
      this.startDate = moment(this.month).startOf('month');
      this.endDate = moment(this.month).endOf('month');
      let dateRangeParams = {"datetime_after": this.startDate.format(), "datetime_before": this.endDate.format()};
      const response = await getTransactionSummary(dateRangeParams);
      this.summary = response.data;
      this.loading = false;
    },
  }
}
</script>
